// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".C4Ijc{display:flex;flex-direction:column;align-items:center}.C4Ijc .bxfRW{display:inline-block;width:100%;flex:0 0 1.5rem}.VLrcM{display:flex;flex-direction:row}.VLrcM>div{flex:1 1 0}", "",{"version":3,"sources":["webpack://src/components/Satellite/Satellite.scss"],"names":[],"mappings":"AAAA,OAAa,YAAY,CAAC,qBAAqB,CAAC,kBAAkB,CAAC,cAAuB,oBAAoB,CAAC,UAAU,CAAC,eAAe,CAAC,OAA0B,YAAY,CAAC,kBAAkB,CAAC,WAA8B,UAAU","sourcesContent":[".legendValue{display:flex;flex-direction:column;align-items:center}.legendValue .colorbar{display:inline-block;width:100%;flex:0 0 1.5rem}.surfaceTemperatureLegend{display:flex;flex-direction:row}.surfaceTemperatureLegend>div{flex:1 1 0}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"legendValue": "C4Ijc",
	"colorbar": "bxfRW",
	"surfaceTemperatureLegend": "VLrcM"
};
export default ___CSS_LOADER_EXPORT___;
